import { render } from "./StudentCustomColumnEditTable.vue?vue&type=template&id=08e25486&scoped=true&ts=true"
import script from "./StudentCustomColumnEditTable.vue?vue&type=script&lang=ts"
export * from "./StudentCustomColumnEditTable.vue?vue&type=script&lang=ts"

import "./StudentCustomColumnEditTable.vue?vue&type=style&index=0&id=08e25486&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\y-tosa.LOCALPSC\\repo\\seto-solan\\apps\\admin-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08e25486"]])

export default __exports__